import { Flex, Text, Title } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconPlus, IconUsersPlus } from '@tabler/icons-react'
import { Button } from 'components/Button'
import { DisabledTooltipButton } from 'components/DisabledTooltipButton'
import { useNotification } from 'context/useNotificationContext'
import { useCurrentUser } from 'context/useCurrentUser'
import { useFeatureToggle } from 'hooks/useFeatureToggle'
import { isEmpty } from 'lodash'
import { AddStudentsModal, useAddStudentsModal } from 'pages/TeacherDashboard/components/AddStudentsModal'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'
import TabContext from '../context/students-context'
import { ITabContext } from '../types/student-types'

const AddStudentsButton = () => {
  const { t } = useTranslation()
  const { open: openAddStudentsModal } = useAddStudentsModal()

  return (
    <Button leftIcon={<IconUsersPlus size={18} />} onClick={() => openAddStudentsModal()} size='md'>
      {t('add_students_modal.title')}
    </Button>
  )
}

export const WrapTitle = () => {
  const { t } = useTranslation()
  const { actions } = useContext<ITabContext>(TabContext)
  const isMobile = useMediaQuery('(max-width: 600px)')
  const { handleNotification } = useNotification()
  const { currentUser } = useCurrentUser()
  const isArcNewProjectEnabled = useFeatureToggle('arc-mosaico-project') as boolean
  const isManager = currentUser?.profile_used === 'manager'

  const [searchParams] = useSearchParams()
  const notification = async () => {
    handleNotification(true, t('student_creation_screen.mensage_sucess'), true)
  }

  useEffect(() => {
    if (searchParams.get('showNotificationCreate')) {
      notification()
    }
  }, [])

  return (
    <>
      {isArcNewProjectEnabled && !isManager && <AddStudentsModal />}
      <Flex direction='row' justify='space-between' align='center'>
        <Flex direction='column' w='fit-content'>
          <Title align='left' order={1}>
            {t('students_index_title')}
          </Title>
          <Text color='gray.6' size='sm'>
            {t('students_sub')}
          </Text>
        </Flex>
        {!isArcNewProjectEnabled && !isMobile && isEmpty(actions.new) && (
          <DisabledTooltipButton label={t('students_new_button')} tooltipLabel={t('students_add_blocked')} />
        )}
        {!isArcNewProjectEnabled && !isMobile && !isEmpty(actions.new) && (
          <Button leftIcon={<IconPlus />} component={Link} to='/learners/new' size='md'>
            {t('students_new_button')}
          </Button>
        )}
        {isArcNewProjectEnabled && !isManager && <AddStudentsButton />}
        {isArcNewProjectEnabled && isManager && (
          <Button leftIcon={<IconPlus />} component={Link} to='/learners/new' size='md'>
            {t('students_new_button')}
          </Button>
        )}
      </Flex>
    </>
  )
}
